// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"ad1edec6","162":"2023db01","244":"85ae9724","272":"22b41b73","391":"7cd58581","398":"627e00a0","453":"7390bbd6","599":"77113893","779":"beb46056","786":"4ae4176e","805":"dab2b6d7","886":"dd2d9f87","930":"7f6442f2","971":"8ad5cc12"}[chunkId] + ".chunk.js";
};